import RightArrowIcon from "@/assets/svgs/right-arrow-icon";
import React from "react";
import { Text, View, Pressable } from "react-native";

function AccountItem({
  title,
  onPress,
}: {
  title: string;
  onPress: () => void;
}) {
  return (
    <Pressable className="px-5 py-4" onPress={onPress}>
      <View className="flex-row items-center justify-between">
        <View className="flex-1">
          <Text className="font-geologica-regular font-normal text-xl text-teachLoop-textPrimary leading-[1.5]">
            {title}
          </Text>
        </View>
        <RightArrowIcon
          pathClassName="stroke-teachLoop-textPrimary"
          className="size-6"
        />
      </View>
    </Pressable>
  );
}

export default AccountItem;